import "./App.css";
import LoginScreen from "./stories/LoginScreen/LoginScreen";

function App() {
  return (
    <LoginScreen/>
  );
}

export default App;
